module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/T-Shirt-1c19abd7c30d4604ea478738ba222fbb.svg";